export const A = {
  bg:             "#FBFBF9",
  surface:        "#EEF2F2",  // oklch(0.97 0.008 215)
  card:           "#FFFFFF",
  ocean:          "#1F7D91",  // primary — oklch(0.52 0.10 215)
  oceanHover:     "#186672",  // oklch(0.46 0.10 215)
  oceanDeep:      "#2A5A66",  // oklch(0.42 0.09 222)
  oceanFooter:    "#16313A",  // oklch(0.22 0.045 224)
  oceanAnnounce:  "#1B3A42",  // oklch(0.27 0.05 222)
  coral:          "#E3704F",  // accent — oklch(0.66 0.16 32)
  coralHover:     "#C9573A",  // oklch(0.60 0.16 32)
  ink:            "#18211C",  // primary text
  muted:          "#5D635F",  // secondary text
  mutedSoft:      "#8A877F",  // tertiary / labels
  border:         "#E6E5E1",
  line:           "#ECECEA",
  success:        "#3FBF7F",  // oklch(0.72 0.14 150)
  successDeep:    "#2E8F5E",  // oklch(0.60 0.14 150)
  amber:          "#D4A027",  // oklch(0.80 0.12 60) — developing tier
};

export const fonts = {
  display: "'Plus Jakarta Sans', system-ui, sans-serif",
  stat:    "'Sora', system-ui, sans-serif",
  body:    "'Spline Sans', system-ui, sans-serif",
};

export const tokens = {
  radius: { card: 12, button: 8, pill: 999, chip: 6 },
  border: {
    thin:  `1px solid ${A.border}`,
    focus: `1.5px solid ${A.ocean}`,
  },
  padding: {
    card:       "24px",
    btnPrimary: "8px 18px",
    btnOutline: "6px 16px",
    btnSm:      "6px 12px",
  },
  shadow: {
    card:  "0 2px 10px rgba(31,125,145,0.06)",
    hover: "0 6px 24px rgba(31,125,145,0.14)",
  },
  label: {
    fontSize:      "0.72rem",
    fontWeight:    700,
    letterSpacing: "0.1em",
    color:         A.muted,
    textTransform: "uppercase",
    marginBottom:  6,
  },
};
